// extracted by mini-css-extract-plugin
module.exports = {"autoSubmitWrapper":"autoSubmit__autoSubmitWrapper___PJLhB","button":"autoSubmit__button___lJofp","icon":"autoSubmit__icon___2ws3J","buttonGroup":"autoSubmit__buttonGroup___1Ouvf"};